var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEmailBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 48,
    viewBox: "0 0 57 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Inputs"
  }, /*#__PURE__*/React.createElement("path", {
    id: "email",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 10.7104V43H51.5V10.7034L32.8389 27.4603C30.3686 29.6786 26.6236 29.6786 24.1533 27.4603L5.5 10.7104ZM50.3679 5H6.62427L27.4939 23.7401C28.064 24.252 28.9282 24.252 29.4983 23.7401L50.3679 5ZM0.5 4.66667C0.5 2.08934 2.58934 0 5.16667 0H51.8333C54.4107 0 56.5 2.08934 56.5 4.66667V43.3333C56.5 45.9107 54.4107 48 51.8333 48H5.16667C2.58934 48 0.5 45.9107 0.5 43.3333V4.66667Z",
    fill: "#38A6D5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailBlue);
export default __webpack_public_path__ + "static/media/icon-email-blue.e03855fd09669626bb5f80efede5c4ed.svg";
export { ForwardRef as ReactComponent };